// extracted by mini-css-extract-plugin
module.exports = {"container":"success-modal_container__1NRMv","image":"success-modal_image__3MWIg","title":"success-modal_title__3XZIn","content":"success-modal_content__1fmcH"};